(function() {
  const tabsArray = document.querySelectorAll('.collectionsList__header .collectionsList__headerListItem');

  document.addEventListener('DOMContentLoaded', function() {
    tabsArray.forEach(tab => {
      tab.addEventListener('click', (event) => {
        toggleTab(event);
      });
    });

    function toggleTab(e) {
      let activeTab = document.querySelector('.collectionsList__header .active--tab'),
          activeSlider = document.querySelector('.collectionsList__itemsWrapper.collectionsList__itemsWrapper--active'),
          currentEvent = e.currentTarget,
          currentSlider = document.querySelector(`.collectionsList__itemsWrapper[data-product-slider="${e.currentTarget.dataset.productTag}"]`);

      activeTab.classList.remove('active--tab');
      currentEvent.classList.add('active--tab');
      activeSlider.classList.remove('collectionsList__itemsWrapper--active');
      currentSlider.classList.add('collectionsList__itemsWrapper--active');
    }
  });
})();
